import React from 'react'

import PropTypes from 'prop-types'

const TitleNews = ({h1}) => {
  return <h1 className="mt-TitleNews">{h1}</h1>
}

TitleNews.displayName = 'TitleNews'

TitleNews.propTypes = {
  h1: PropTypes.string
}

TitleNews.defaultProps = {
  h1: ''
}

export default TitleNews
